import { SVGProps } from 'react';

/** Outline gear for header buttons. The viewBox is padded so the stroke isn't clipped. */
export const SettingsOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-icon
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="-1.51 -0.6 23.2 23.2"
    fill="none"
    {...props}
  >
    <path
      d="M8.51919 1.83325C9.20494 0.598547 10.9806 0.598545 11.6664 1.83325L12.2459 2.87679C12.6523 3.6085 13.5095 3.96354 14.3142 3.7335L15.4619 3.40544C16.8199 3.01727 18.0755 4.27285 17.6873 5.63082L17.3593 6.77854C17.1292 7.5833 17.4843 8.44044 18.216 8.84683L19.2595 9.42641C20.4942 10.1122 20.4942 11.8878 19.2595 12.5736L18.216 13.1532C17.4843 13.5596 17.1292 14.4167 17.3593 15.2215L17.6873 16.3692C18.0755 17.7271 16.8199 18.9827 15.462 18.5946L14.3142 18.2665C13.5095 18.0365 12.6523 18.3915 12.2459 19.1232L11.6664 20.1667C10.9806 21.4015 9.20494 21.4015 8.51919 20.1667L7.93961 19.1232C7.53321 18.3915 6.67608 18.0365 5.87132 18.2665L4.7236 18.5946C3.36563 18.9827 2.11004 17.7271 2.49821 16.3692L2.82628 15.2215C3.05631 14.4167 2.70128 13.5596 1.96956 13.1532L0.926028 12.5736C-0.308679 11.8878 -0.308681 10.1122 0.926026 9.42641L1.96956 8.84683C2.70127 8.44044 3.05631 7.5833 2.82628 6.77854L2.49821 5.63083C2.11004 4.27285 3.36563 3.01727 4.7236 3.40544L5.87131 3.7335C6.67608 3.96354 7.53321 3.6085 7.93961 2.87679L8.51919 1.83325Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <circle cx="10.0928" cy="11" r="4.05" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
